import {
  countryCodeColumnDefinition,
  countryNameColumnDefinition,
  currencyCodeColumnDefinition,
  enabledFlagColumnDefinition,
  precisionColumnDefinition,
} from '../columnDefinitions';

export const clientAdministrationCurrenciesColumnDefinitions = [
  currencyCodeColumnDefinition,
  enabledFlagColumnDefinition,
  precisionColumnDefinition,
];

export default [
  countryCodeColumnDefinition,
  countryNameColumnDefinition,
  currencyCodeColumnDefinition,
  precisionColumnDefinition,
];
